import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import Home from "../views/Home";
import Nosotros from "../views/Nosotros";
import Servicios from "../views/Servicios";
import Productos from "../views/Productos";
import Comunidad from "../views/Comunidad";
import Noticias from "../views/Noticias";
import Contacto from "../views/Contacto";
import Entrada1 from "../views/Espacios_de_trabajo_para_todos";
import Entrada2 from "../views/Hogar_accesible_vida_autonoma";
import Page404 from "../components/page404";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/productos" element={<Productos />} />
          <Route path="/comunidad" element={<Comunidad />} />
          <Route path="/noticias" element={<Noticias />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route
            path="/espacio-de-trabajo-para-todos"
            element={<Entrada1 />}
          />
          <Route
            path="/hogar-accesible-vida-autonoma"
            element={<Entrada2 />}
          />
          <Route
            path="/hogar-accesible-vida-automata"
            element={<Navigate to="/hogar-accesible-vida-autonoma" replace />}
          />
          <Route path="*" element={<Page404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
